import gotinLogin from '@frontend/gotin-sdk-login'

const loginSDK = new gotinLogin({
  continueUrl: process.env.VUE_APP_LOGIN_URL,
  baseUrl: process.env.VUE_APP_AUTH_URI,
  creationUrl: process.env.VUE_APP_API_GATEWAY,
})

export default loginSDK
